import { lazy, Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import DashboardPage from 'pages/Dashboard';
import { MainLayout } from 'components/layout';
import { LinearProgress } from 'components/primitives';
import AuthPage from '@/auth';

const JSXRoutes = (): ReturnType<typeof createBrowserRouter> => {
  const LoginPage = lazy(() => import('pages/Login'));
  const DisplayViewsPage = lazy(() => import('pages/DisplayViews'));
  const PrintViewsPage = lazy(() => import('pages/PrintViews'));
  const SettingsPage = lazy(() => import('pages/DbSettings'));
  const StatusReportPage = lazy(() => import('pages/StatusReport'));

  return createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={<AuthPage />}>
        <Route path='dashboard' element={<MainLayout />}>
          <Route index element={<DashboardPage />} />
        </Route>
        <Route
          path='settings'
          element={
            <Suspense fallback={<LinearProgress />}>
              <SettingsPage />
            </Suspense>
          }
        />
        <Route
          path='login'
          element={
            <Suspense fallback={<LinearProgress />}>
              <LoginPage />
            </Suspense>
          }
        />
        <Route path='display-view'>
          <Route
            path='sigevents'
            element={
              <Suspense fallback={<LinearProgress />}>
                <DisplayViewsPage app={'sigevents'} />
              </Suspense>
            }
          />
          <Route
            path='operationalrhythm'
            element={
              <Suspense fallback={<LinearProgress />}>
                <DisplayViewsPage app={'operationalrhythm'} />
              </Suspense>
            }
          />
          <Route
            path='battlerhythm'
            element={
              <Suspense fallback={<LinearProgress />}>
                <DisplayViewsPage app={'battlerhythm'} />
              </Suspense>
            }
          />
          <Route
            path='positionlogs'
            element={
              <Suspense fallback={<LinearProgress />}>
                <DisplayViewsPage app={'positionlogs'} />
              </Suspense>
            }
          />
        </Route>
        <Route path='reports-view'>
          <Route
            path='summary-status'
            element={
              <Suspense fallback={<LinearProgress />}>
                <StatusReportPage />
              </Suspense>
            }
          />
        </Route>
        <Route path='print-view'>
          <Route
            path='resourcerequest'
            element={
              <Suspense fallback={<LinearProgress />}>
                <PrintViewsPage app={'resourcerequest'} />
              </Suspense>
            }
          />
          <Route
            path='sigevents'
            element={
              <Suspense fallback={<LinearProgress />}>
                <PrintViewsPage app={'sigevents'} />
              </Suspense>
            }
          />
        </Route>
        <Route
          path='*'
          element={
            <Suspense fallback={<LinearProgress />}>
              <LoginPage />
            </Suspense>
          }
        />
      </Route>
    )
  );
};

export default JSXRoutes;
